if (!customElements.get("ac-cart-drawer") && customElements.get("ona-cart-drawer")) {
  const OnaCartDrawer = customElements.get("ona-cart-drawer");
  const getMobileSubscriptionProps = (variantId) => window.acMobileSubscriptionPresets.find(({ variants }) => variants.includes(variantId));
  class AcCartDrawer extends OnaCartDrawer {
    constructor() {
      super();
      this._subscriptionKeyByVariantId = {};
      this.addEventListener("beforeRender", () => {
        this._subscriptionKeyByVariantId = {};
      });
      this.addEventListener("renderLine", (event) => {
        var _a, _b;
        const { item, lineElement } = event.detail;
        if ((_a = item == null ? void 0 : item.properties) == null ? void 0 : _a._camera) {
          if (lineElement) {
            lineElement.setAttribute("part", "line line--mobile-subscription");
            const cameraVariantId = item.properties._camera;
            lineElement.setAttribute("data-camera", cameraVariantId);
            this._subscriptionKeyByVariantId[cameraVariantId] = item.key;
            lineElement.querySelector('[part="line-quantity"]').remove();
          }
        } else if ((_b = item == null ? void 0 : item.properties) == null ? void 0 : _b["_mob-subscription"]) {
          if (lineElement) {
            lineElement.setAttribute("part", "line line--with-subscription");
            lineElement.setAttribute("data-subscription", item.properties["_mob-subscription"]);
          }
        }
      });
      this.addEventListener("afterRender", () => {
        const itemsEl = this.shadowRoot.querySelector(".items");
        Object.entries(this._subscriptionKeyByVariantId).forEach(([variantId, subscriptionLineKey]) => {
          const variantItemEl = itemsEl.querySelector(`[data-line-key^="${variantId}:"]`);
          const subItemEl = itemsEl.querySelector(`[data-line-key^="${subscriptionLineKey}"]`);
          if (variantItemEl && subItemEl) {
            variantItemEl.append(subItemEl);
          } else {
            console.error("[AC Cart] Could not nest subscription into camera: ", variantId, subscriptionLineKey);
          }
        });
      });
      this.addEventListener("beforeUpdate", (event) => {
        const { updates } = event.detail;
        Object.keys(updates).forEach((lineKey) => {
          const [variantId, _hash] = lineKey.split(":");
          const subscriptionLineKey = this._subscriptionKeyByVariantId[variantId];
          if (subscriptionLineKey) {
            updates[subscriptionLineKey] = updates[lineKey];
          }
        });
      });
      this.addEventListener("readychange", (event) => {
        const { isReady } = event.detail;
        this.querySelector(".cart-drawer__checkout-button").classList.toggle("button--disabled", !isReady);
        const itemsEl = this.shadowRoot.querySelector(".items");
        itemsEl.querySelectorAll("ac-number-input").forEach((inputEl) => {
          if (isReady) inputEl.removeAttribute("disabled");
          else inputEl.setAttribute("disabled", "");
        });
        if (!isReady) {
          this.querySelector(".cart-drawer__total-value").innerHTML = "<ona-spinner></ona-spinner>";
        }
      });
      this.addEventListener("sumQuantity", (event) => {
        var _a;
        const { item } = event.detail;
        const isSubscription = (_a = item == null ? void 0 : item.properties) == null ? void 0 : _a._camera;
        if (isSubscription) {
          event.detail.itemQuantity = 0;
        }
      });
    }
    connectedCallback() {
      super.connectedCallback();
      this.refresh();
    }
  }
  customElements.define("ac-cart-drawer", AcCartDrawer);
}
